var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      !_vm.mobileView
        ? _c("div", [
            _c("div", { attrs: { id: "subheader" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "main-container" } }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { attrs: { id: "container" } }, [
                _c(
                  "div",
                  { attrs: { id: "list-container" } },
                  _vm._l(_vm.items, function(item) {
                    return _c("item-estado-pedido", {
                      attrs: { id: "list-prod", item: item },
                      on: { borradorEliminado: _vm.getEstadoPedidos }
                    })
                  })
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "fv ct",
                staticStyle: {
                  width: "100vw",
                  height: "100vh",
                  "margin-top": "40px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "4%",
                      background: "#44C7F4",
                      color: "white",
                      font: "size 12px"
                    }
                  },
                  [_vm._v("Estado de Presupuestos")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv ct",
                    staticStyle: { width: "100%", height: "80%" }
                  },
                  _vm._l(_vm.items, function(item) {
                    return _c("item-estado-pedido", {
                      attrs: { item: item },
                      on: { borradorEliminado: _vm.getEstadoPedidos }
                    })
                  })
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Estado de Presupuestos")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26b7e2e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b7e2e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPresupuesto/estadoPresupuesto.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-26b7e2e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPresupuesto/estadoPresupuesto.vue
// module chunks = 0